import { render, staticRenderFns } from "./MailboxManager.vue?vue&type=template&id=8d83bf4c&scoped=true"
import script from "./MailboxManager.vue?vue&type=script&lang=js"
export * from "./MailboxManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d83bf4c",
  null
  
)

export default component.exports